import axiosInstance from "api/setupAxios";

const projectsApi = {
  getAgencyProjects: async (agencyId, query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    const { data } = await axiosInstance.get(`/agency/${agencyId}/projects`, {
      params: {
        paginate: JSON.stringify({
          pageSize: pageSize,
          pageNumber,
        }),
        sort: JSON.stringify([["created_at", "desc"]]),
        filter: JSON.stringify(query.filter),
      },
    });

    return data.data || data;
  },

  getAssigneesPerProject: async (agencyId, projectId) => {
    const { data } = await axiosInstance.get(
      `/agency/${agencyId}/project/${projectId}/listPo`,
      {}
    );

    return data?.data?.result ?? data?.result ?? data?.data ?? data ?? [];
  },

  getVendorTasks: async (vendorId, query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    const { data } = await axiosInstance.get(`/vendor/${vendorId}/tasks`, {
      params: {
        paginate: JSON.stringify({ pageSize, pageNumber }),
        sort: JSON.stringify([["created_at", "desc"]]),
        filter: JSON.stringify(query.filter),
      },
    });

    return data.data || data;
  },

  gitRefFileUrlApi: async (fileId) => {
    const { data } = await axiosInstance.get(
      `/user/referenceFile/${fileId}/url`
    );
    return data;
  },

  // Get a signed URL for a parent file (source file) download
  downloadParentFile: async (fileId) => {
    const { data } = await axiosInstance.get(
      `/user/${fileId}/downloadParentFile`
    );

    return data?.data || data;
  },

  uploadDeliverableFile: async (assigneeId, payload = {}) => {
    const { data } = await axiosInstance.post(
      `/user/${assigneeId}/deliverables`,
      payload
    );
    return data;
  },
};

export default projectsApi;
